// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";

interface paramsType {
  id: number;
  notificationID: string | number;
}

export function useRefuseInvoiceMutation(
  onSuccessMutation?: (data: any, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function refuseInvoice(params: paramsType): Promise<any> {
    const response = await api.post<any>(
      `invoices/invoices/${params.id}/refuse`
    );

    if (!response.ok) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: refuseInvoice,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
